import React, { Component } from 'react';
//import Waypoint  from 'react-waypoint';

// import '../css/GreenSection.scss';

import car from '../img/car.svg';

class GreenSection extends Component {
  constructor(props) {
    super(props);

    this.scroll = 0;
    this.height = 0;
    this.fromTop = 0;

    this._scroll = this._scroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this._scroll);
  }

  render() {
    /*
    <Waypoint
      ref="section"
      onEnter={this._handleWaypointEnter}
      onLeave={this._handleWaypointLeave}
      >*/
    return (

        <div ref="section" className="green-section2">
          <div ref="green1" className="green-section-inner">
            <h1>Maternal health needs in Pennsylvania</h1>

            <div className="group">
              <div className="third">
                <div className="small">The Maternal mortality rate in Philadelphia is</div>
                <div ref="number3" className="bold">27.4</div>
                <div className="medium">DEATHS</div>
                <div className="small-large">per 100,000 live births</div>
              </div>
              <div className="third">
                <div ref="number1" className="bold">74%</div>
                <div className="small">of pregnancy-related deaths in Philadelphia were Black women</div>
              </div>
              <div className="third">
                <div className="thirty"><span ref="number2">29%</span></div>
                <div className="small">of women in PA were told they have high blood pressure, a risk factor for poor maternal health outcomes</div>
              </div>

            </div>
          </div>

          <div ref="green2" className="green-section-inner">
            <h1>MATERNITY CARE COALITION’S REACH</h1>

            <div className="group">
              <div className="third flex">
                <div className="mom"></div>
                <div className="right">
                  <div ref="number5" className="bold">297</div>
                  <div className="small-large">HEALTHY BIRTHS</div>
                  <div className="small">with the labor support of MCC Doulas and Advocates</div>
                </div>
              </div>
              <div className="third">
                <div ref="number4" className="bold bottom-pad">11,069</div>
                <img src={car} className="car" alt="car"/>
                <div className="small-large">HOME VISITS</div>
                <div className="small">were completed across all MCC home-visiting based programs</div>
              </div>
              <div className="third">
                <div ref="number6" className="bold bottom-pad">4512</div>
                <div className="small">clients served across all MCC programs</div>
              </div>

            </div>
          </div>


        </div>
    );
  }

  _handleWaypointEnter() {
    console.log('enter');
    //this.height = this.refs.section.height;
  }

  _handleWaypointLeave() {
    console.log('position leave');
  }

  _scroll() {
    if(window.innerWidth < 800) return;

    this.height = this.refs.section.offsetHeight;
    console.log(this.height);
    this.fromTop = this.refs.section.getBoundingClientRect().top;

    if(this.fromTop < window.innerHeight && this.fromTop >= 0) {
      let pct = 1 - this.fromTop / this.height;
      let n = -100*(1-pct);
      let o = 100*(1-pct);
      this.refs.green1.style.transform = 'translateX('+n+'%)';
      this.refs.green2.style.transform = 'translateX('+o+'%)';

      // numbers
      this.refs.number1.innerHTML = Math.ceil(74*pct) + '%';
      this.refs.number2.innerHTML = Math.ceil(29*pct) + '%';
      this.refs.number3.innerHTML = Math.round(27.4*pct);
      this.refs.number4.innerHTML = Math.ceil(11069*pct).toLocaleString();
      this.refs.number5.innerHTML = Math.ceil(266*pct);
      this.refs.number6.innerHTML = Math.ceil(4512*pct).toLocaleString();
    } else {
      if(this.fromTop < 0) {
        this.refs.green1.style.transform = 'translateX(0%)';
        this.refs.green2.style.transform = 'translateX(0%)';
      }
      this.refs.number1.innerHTML = '74%';
      this.refs.number2.innerHTML = '29%';
      this.refs.number3.innerHTML = 27.4;
      this.refs.number4.innerHTML = (11069).toLocaleString();
      this.refs.number5.innerHTML = 266;
      this.refs.number6.innerHTML = '4,512';
    }
  }
}

export default GreenSection;



// WEBPACK FOOTER //
// ./src/js/GreenSection.js